/**
 * What the live app knows about the marks beside the rows (D334), composed
 * ONCE — the sidebar and the search sheet both draw a row's mark, and two
 * compositions of the same facts are how the two would come to disagree about
 * a row, the reason D103 gave for `unreadRun` being one predicate.
 *
 * Two sources, neither of them the index. The store says whether a run is
 * live, and a run only ever runs in the open exploration, so that is the one
 * place its ring can be. The conversations say where an answer is still
 * arriving and where one landed unseen (`useConversationMarks`); an answer
 * arriving in the open exploration is being watched, so its ring is not drawn.
 * The pure rule that turns these into a mark is `rowMark` in `core/unread.ts`.
 */

import { useMemo } from 'react'
import { useStore } from '../core/store'
import type { LiveMarks } from '../core/unread'
import { useConversationMarks } from './askLive'

export function useRowMarks(): LiveMarks {
  const openId = useStore((s) => s.session.id)
  // The pane's and the sheet's own reading of a live run: moving or waiting at
  // the confirm gate both count, and the ring is also why every other row
  // refuses a press while it is up. A single pass is not a run — see the
  // header of `core/unread.ts`.
  const runLive = useStore((s) => s.run !== null && s.run.phase !== 'ended')
  const chat = useConversationMarks()
  return useMemo(
    () => ({
      running: [...(runLive ? [openId] : []), ...chat.arrivingIn.filter((id) => id !== openId)],
      answeredAt: chat.answeredAt,
    }),
    [openId, runLive, chat],
  )
}
